import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { ScreenInitializationComponent } from './component/app-initialization.component';
import { InitializationService } from './initialization.service';

@Component({
	selector: 'app-initialization',
	templateUrl: './initialization.page.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, RouterModule, ScreenInitializationComponent],
	host: {
		class: 'dis-block w-100 h-100',
	},
})
export class InitializationPageComponent {
	private readonly router = inject(Router);
	private readonly service = inject(InitializationService);
	private readonly fontsLoaded$$ = new BehaviorSubject(false);
	public readonly fontsLoaded$ = this.fontsLoaded$$.asObservable();

	private readonly sessionLoaded$$ = new BehaviorSubject(false);
	public readonly sessionLoaded$ = this.sessionLoaded$$.asObservable();

	private readonly loaded$$ = new BehaviorSubject(false);
	public readonly loaded$ = this.loaded$$.asObservable();

	public async _onAppInitialized(): Promise<void> {
		this.router.navigateByUrl(this.router.url, {
			skipLocationChange: false,
			replaceUrl: true,
			onSameUrlNavigation: 'reload',
		});
		this.service.setState(true);
		this.sessionLoaded$$.next(true);
		this.loaded$$.next(true);
	}
}
